import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentPage.css';

function PaymentPage() {
  const navigate = useNavigate();
  const [paymentStep, setPaymentStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('credit');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // Ödeme bilgileri state
  const [paymentInfo, setPaymentInfo] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    cardHolder: '',
    amount: '',
    description: 'Course Tuition Fee'
  });

  // Öğrenci ve kurs bilgileri
  const studentInfo = {
    name: 'Ahmet Yılmaz',
    studentId: 'STU2024001',
    email: 'ahmet@example.com',
    program: 'Leadership Development Program'
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    // Ödeme işlemi simülasyonu
    try {
      await new Promise(resolve => setTimeout(resolve, 3000));
      setIsSuccess(true);
      setPaymentStep(3);
    } catch (error) {
      console.error('Payment failed:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="payment-wrapper">
      {/* Header */}
      <header className="payment-header">
        <div className="payment-container">
          <h1>Secure Payment Portal</h1>
        </div>
      </header>

      {/* Progress Steps */}
      <section className="payment-progress">
        <div className="payment-container">
          <div className="progress-steps">
            <div className={`progress-step ${paymentStep >= 1 ? 'active' : ''}`}>
              <div className="step-number">1</div>
              <div className="step-label">Payment Details</div>
            </div>
            <div className={`progress-step ${paymentStep >= 2 ? 'active' : ''}`}>
              <div className="step-number">2</div>
              <div className="step-label">Review & Pay</div>
            </div>
            <div className={`progress-step ${paymentStep >= 3 ? 'active' : ''}`}>
              <div className="step-number">3</div>
              <div className="step-label">Confirmation</div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="payment-main">
        <div className="payment-container">
          <div className="payment-content">
            
            {/* Student Info Sidebar */}
            <aside className="payment-sidebar">
              <div className="student-info-card">
                <h3>Student Information</h3>
                <div className="info-item">
                  <label>Name:</label>
                  <span>{studentInfo.name}</span>
                </div>
                <div className="info-item">
                  <label>Student ID:</label>
                  <span>{studentInfo.studentId}</span>
                </div>
                <div className="info-item">
                  <label>Email:</label>
                  <span>{studentInfo.email}</span>
                </div>
                <div className="info-item">
                  <label>Program:</label>
                  <span>{studentInfo.program}</span>
                </div>
              </div>

              <div className="payment-summary">
                <h3>Payment Summary</h3>
                <div className="summary-item">
                  <span>Tuition Fee:</span>
                  <span>$1,500.00</span>
                </div>
                <div className="summary-item">
                  <span>Tax:</span>
                  <span>$150.00</span>
                </div>
                <div className="summary-item total">
                  <span>Total Amount:</span>
                  <span>$1,650.00</span>
                </div>
              </div>

              <div className="security-badge">
                <div className="security-icon">🔒</div>
                <div className="security-text">
                  <h4>Secure Payment</h4>
                  <p>Your payment information is encrypted and secure</p>
                </div>
              </div>
            </aside>

            {/* Payment Form */}
            <div className="payment-form-section">
              {paymentStep === 1 && (
                <div className="payment-step">
                  <h2>Payment Method</h2>
                  <div className="payment-methods">
                    <div 
                      className={`method-card ${paymentMethod === 'credit' ? 'selected' : ''}`}
                      onClick={() => setPaymentMethod('credit')}
                    >
                      <div className="method-icon">💳</div>
                      <div className="method-info">
                        <h4>Credit/Debit Card</h4>
                        <p>Visa, MasterCard, American Express</p>
                      </div>
                    </div>
                    
                    <div 
                      className={`method-card ${paymentMethod === 'bank' ? 'selected' : ''}`}
                      onClick={() => setPaymentMethod('bank')}
                    >
                      <div className="method-icon">🏦</div>
                      <div className="method-info">
                        <h4>Bank Transfer</h4>
                        <p>Direct bank transfer</p>
                      </div>
                    </div>
                    
                    <div 
                      className={`method-card ${paymentMethod === 'digital' ? 'selected' : ''}`}
                      onClick={() => setPaymentMethod('digital')}
                    >
                      <div className="method-icon">📱</div>
                      <div className="method-info">
                        <h4>Digital Wallet</h4>
                        <p>PayPal, Apple Pay, Google Pay</p>
                      </div>
                    </div>
                  </div>

                  <button 
                    className="btn-primary"
                    onClick={() => setPaymentStep(2)}
                  >
                    Continue to Payment
                  </button>
                </div>
              )}

              {paymentStep === 2 && (
                <div className="payment-step">
                  <h2>Payment Details</h2>
                  
                  {paymentMethod === 'credit' && (
                    <form className="credit-card-form" onSubmit={handlePaymentSubmit}>
                      <div className="form-group">
                        <label>Card Number</label>
                        <input
                          type="text"
                          name="cardNumber"
                          placeholder="1234 5678 9012 3456"
                          value={paymentInfo.cardNumber}
                          onChange={handleInputChange}
                          maxLength="19"
                        />
                      </div>
                      
                      <div className="form-row">
                        <div className="form-group">
                          <label>Expiry Date</label>
                          <input
                            type="text"
                            name="expiryDate"
                            placeholder="MM/YY"
                            value={paymentInfo.expiryDate}
                            onChange={handleInputChange}
                            maxLength="5"
                          />
                        </div>
                        
                        <div className="form-group">
                          <label>CVV</label>
                          <input
                            type="text"
                            name="cvv"
                            placeholder="123"
                            value={paymentInfo.cvv}
                            onChange={handleInputChange}
                            maxLength="3"
                          />
                        </div>
                      </div>
                      
                      <div className="form-group">
                        <label>Card Holder Name</label>
                        <input
                          type="text"
                          name="cardHolder"
                          placeholder="John Doe"
                          value={paymentInfo.cardHolder}
                          onChange={handleInputChange}
                        />
                      </div>
                      
                      <div className="form-group">
                        <label>Amount</label>
                        <div className="amount-input">
                          <span className="currency">$</span>
                          <input
                            type="text"
                            name="amount"
                            value="1,650.00"
                            readOnly
                            className="readonly"
                          />
                        </div>
                      </div>

                      <div className="form-actions">
                        <button 
                          type="button" 
                          className="btn-secondary"
                          onClick={() => setPaymentStep(1)}
                        >
                          Back
                        </button>
                        <button 
                          type="submit" 
                          className="btn-primary"
                          disabled={isProcessing}
                        >
                          {isProcessing ? (
                            <>
                              <span className="spinner"></span>
                              Processing...
                            </>
                          ) : (
                            'Pay $1,650.00'
                          )}
                        </button>
                      </div>
                    </form>
                  )}

                  {/* Diğer ödeme yöntemleri için benzer formlar eklenebilir */}
                </div>
              )}

              {paymentStep === 3 && (
                <div className="payment-step confirmation-step">
                  <div className="confirmation-icon">✅</div>
                  <h2>Payment Successful!</h2>
                  <p className="confirmation-message">
                    Your payment of <strong>$1,650.00</strong> has been processed successfully.
                  </p>
                  
                  <div className="confirmation-details">
                    <div className="detail-item">
                      <label>Transaction ID:</label>
                      <span>TXN20241234567</span>
                    </div>
                    <div className="detail-item">
                      <label>Date:</label>
                      <span>{new Date().toLocaleDateString()}</span>
                    </div>
                    <div className="detail-item">
                      <label>Payment Method:</label>
                      <span>Credit Card</span>
                    </div>
                  </div>

                  <div className="confirmation-actions">
                    <button className="btn-secondary" onClick={() => window.print()}>
                      Print Receipt
                    </button>
                    <button className="btn-primary" onClick={handleBackToHome}>
                      Back to Home
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="payment-footer">
        <div className="payment-container">
          <p>© 2024 Adam Academy. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/contact">Contact Support</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PaymentPage;